const dateOnlyPattern = /^(\d{4})-(\d{2})-(\d{2})$/;

export function parseCalendarDate(dateString: string): Date | null {
  const match = dateOnlyPattern.exec(dateString);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(dateString);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatCalendarDate(dateString: string): string {
  const date = parseCalendarDate(dateString);

  return date
    ? date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "Unknown date";
}

export function getCalendarYear(dateString: string): string {
  const date = parseCalendarDate(dateString);
  return date ? date.getFullYear().toString() : "";
}
